/** Static label shown in the animated "Getting ready" badge (dots are animated separately). */
export const GENERATING_BADGE_LABEL = 'Getting ready';
export const GENERATING_SUBTITLE = 'Your video will be ready in less than a minute';
export const GENERATING_FALLBACK_TITLE = 'Preparing your video…';

export const TUTORIAL_VIDEO_SRC = 'https://static.rask.ai/raskapp/how_to_get_started_tutorial.mp4';

/** Percent-driven titles. Both flows derive the title from the displayed percent. Last entry is held. */
export const PERCENT_TITLE_STEPS: { title: string; upTo: number }[] = [
  { title: 'Uploading your video…', upTo: 8 },
  { title: 'Separating noises…', upTo: 20 },
  { title: 'Transcribing speech…', upTo: 34 },
  { title: 'Splitting into phrases…', upTo: 48 },
  { title: 'Detecting speakers…', upTo: 62 },
  { title: 'Choosing the best voices…', upTo: 74 },
  { title: 'Translating your script…', upTo: 85 },
  { title: 'Generating the voiceover…', upTo: 95 },
  { title: 'Putting it all together…', upTo: 100 },
];
